module.exports = __webpack_public_path__ + "img/2.99e97719.png";